import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from '../utils/cn.js';

export interface TagProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  pressed?: boolean;
}

/**
 * Toggleable tag (filter selector or skill picker). `aria-pressed` reflects state.
 */
export const Tag = forwardRef<HTMLButtonElement, TagProps>(function Tag(
  { pressed, className, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      className={cn('tag', pressed && 'is-on', className)}
      aria-pressed={pressed}
      {...rest}
    />
  );
});
